export default {
  'pages.setting.menu.title': '菜单管理',
  'pages.setting.menu.subtitle': '配置总部和租户平台菜单',
  'pages.setting.menu.searchPlaceholder': '搜索菜单名称或路径',
  // 平台
  'pages.setting.menu.platform.hq': '总部平台',
  'pages.setting.menu.platform.tenant': '租户平台',
  'pages.setting.menu.platform.app': 'app平台',
  // 表格列
  'pages.setting.menu.column.menuName': '菜单名称',
  'pages.setting.menu.column.icon': '图标',
  'pages.setting.menu.column.path': '菜单路由',
  'pages.setting.menu.column.menuType': '菜单类型',
  'pages.setting.menu.column.perms': '权限标识',
  'pages.setting.menu.column.orderNum': '排序',
  'pages.setting.menu.column.visible': '是否可见',
  'pages.setting.menu.column.operation': '操作',
  // 菜单类型
  'pages.setting.menu.type.directory': '目录',
  'pages.setting.menu.type.menu': '菜单',
  'pages.setting.menu.type.button': '按钮',
  // 操作
  'pages.setting.menu.add': '新增菜单',
  // 弹窗标题
  'pages.setting.menu.modal.addTitle': '新增菜单',
  'pages.setting.menu.modal.editTitle': '编辑菜单',
  // 表单
  'pages.setting.menu.form.menuName': '菜单名称',
  'pages.setting.menu.form.menuNamePlaceholder': '请输入菜单名称',
  'pages.setting.menu.form.menuNameRequired': '请输入菜单名称',
  'pages.setting.menu.form.path': '菜单路径',
  'pages.setting.menu.form.pathPlaceholder': '请输入菜单路径',
  'pages.setting.menu.form.pathRequired': '请输入菜单路径',
  'pages.setting.menu.form.icon': '图标',
  'pages.setting.menu.form.iconPlaceholder': '请选择图标',
  'pages.setting.menu.form.parentId': '上级菜单',
  'pages.setting.menu.form.parentIdPlaceholder': '请选择上级菜单',
  'pages.setting.menu.form.menuType': '类型',
  'pages.setting.menu.form.menuTypePlaceholder': '请选择类型',
  'pages.setting.menu.form.menuTypeRequired': '请选择类型',
  'pages.setting.menu.form.orderNum': '排序',
  'pages.setting.menu.form.orderNumPlaceholder': '请输入排序号',
  'pages.setting.menu.form.perms': '权限代码',
  'pages.setting.menu.form.permsPlaceholder': '例如：user:view, tenant:edit',
  'pages.setting.menu.form.permsRequired': '请输入权限代码',
  'pages.setting.menu.form.visible': '是否显示',
  'pages.setting.menu.form.visibleRequired': '请选择是否显示',
  'pages.setting.menu.form.status': '是否启用',
  'pages.setting.menu.form.statusRequired': '请选择是否启用',
  // 通用选项
  'pages.setting.menu.option.yes': '是',
  'pages.setting.menu.option.no': '否',
  // 提示消息
  'pages.setting.menu.message.deleteSuccess': '删除成功',
  'pages.setting.menu.message.addSuccess': '新增成功',
  'pages.setting.menu.message.editSuccess': '编辑成功',
};
